import { TAKE } from '@/lib/constants/pagination';
import type { BaseFilterDto } from '@repo/api';
import { infiniteQueryOptions } from '@tanstack/react-query';
import { fetchInvitedUser } from './api';

export const tenantQueryKeys = {
  all: () => ['tenants'] as const,
  details: () => [...tenantQueryKeys.all(), 'detail'] as const,
  userTenants: () => [...tenantQueryKeys.all(), 'user-tenants'] as const,
  tenantMe: (tenantId?: string) =>
    [...tenantQueryKeys.all(), 'tenant-me', tenantId] as const,
  infinites: () => [...tenantQueryKeys.all(), 'infinite'],
  infinite: (tenantId: string, filters: BaseFilterDto) =>
    infiniteQueryOptions({
      queryKey: [...tenantQueryKeys.infinites(), tenantId, filters],
      queryFn: ({ pageParam = 0 }) => {
        const fetchParams = {
          ...filters,
          skip: pageParam * TAKE,
          take: TAKE,
        };
        return fetchInvitedUser(tenantId, fetchParams);
      },
      initialPageParam: 0,
      getNextPageParam: (lastPage, allPages) => {
        const loadedItems = allPages.reduce(
          (sum, page) => sum + page.data.length,
          0
        );
        if (loadedItems >= lastPage.totalCount) {
          return undefined;
        }
        return allPages.length;
      },
    }),
};
